import { SEND_EMAIL_COMMUNICATION, SEND_EMAIL_COMMUNICATION_SUCCESS, SEND_EMAIL_COMMUNICATION_ERROR, SEND_EMAIL_COMMUNICATION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendEmailCommunication = (state = initialState, action) => {
  switch (action.type) {
    case SEND_EMAIL_COMMUNICATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_EMAIL_COMMUNICATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_EMAIL_COMMUNICATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_EMAIL_COMMUNICATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendEmailCommunication;
